import {DialogFragment, PageFragment, PageFragmentProps} from "@/shared/PageFragment";
import {Box} from "@mui/material";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {PAGE_FRAGMENT_LG_WIDTH} from "@/shared/dimens";
import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "@/shared/BaseApp";
import React from "react";
import {Case, Cases} from "../../../zyrcona-shared/types";

export class EditCaseHelper {

  static addCase(patientId?: string) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditCaseFragment patientId={patientId} onCaseSaved={case_ => BaseApp.CONTEXT.hideDialog()}/>);
  }

  static editCase(case_: Case) {
    BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <EditCaseFragment
        edit={case_}
        onCaseSaved={case_ => BaseApp.CONTEXT.hideDialog()}/>);
  }
}

type EditCaseFragmentProps = PageFragmentProps & {
  patientId?: string,
  edit?: Case,
  onCaseSaved: (case_: Case) => void,
}

class EditCaseFragment extends DialogFragment<EditCaseFragmentProps> {

  private readonly cases = Cases.getInstance();
  private readonly case = this.props.edit ? this.props.edit : Case.createNew(this.props.patientId);

  protected onCreateState() {
    return {
      ...super.onCreateState(),
      title: this.props.edit ? "Edit Profile" : "Add Profile",
    };
  }

  protected styleFlags(): number {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return this.props.edit ? "Save" : "Add";
  }

  onActionButtonClicked() {
    this.addCase().then(() => this.props.onCaseSaved(this.case));
  }

  private async addCase() {
    await this.cases.addListItem(this.case);
  }

  renderContent(): React.ReactElement | null {
    return <Box style={{display: "flex", width: "92dvw", maxWidth: PAGE_FRAGMENT_LG_WIDTH}}>
      <FormGenContainer
        mode={this.props.edit ? FormGenContainerMode.EDIT : FormGenContainerMode.CREATE}
        content={this.case}
        onContainerRequiredItemsFilledChanged={(container, filled) => this.setActionButtonEnabled(filled)}/>
    </Box>;
  }
}
